var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67445 1.44169C6.29742 0.480564 7.10891 2.17913e-08 7.99999 0C8.89106 -2.17913e-08 9.70255 0.480564 11.3255 1.44169L11.8744 1.76677C13.4974 2.72789 14.3089 3.20846 14.7544 4C15.2 4.79154 15.2 5.75267 15.2 7.67493V8.32507C15.2 10.2473 15.2 11.2085 14.7544 12C14.3089 12.7915 13.4974 13.2721 11.8744 14.2332L11.3255 14.5583C9.70255 15.5194 8.89106 16 7.99999 16C7.10891 16 6.29742 15.5194 4.67445 14.5583L4.12552 14.2332C2.50255 13.2721 1.69106 12.7915 1.24553 12C0.799988 11.2085 0.799988 10.2473 0.799988 8.32507V7.67493C0.799988 5.75267 0.799988 4.79154 1.24553 4C1.69106 3.20846 2.50255 2.72789 4.12552 1.76677L4.67445 1.44169ZM8.79999 11.2C8.79999 11.6418 8.44182 12 7.99999 12C7.55816 12 7.19999 11.6418 7.19999 11.2C7.19999 10.7582 7.55816 10.4 7.99999 10.4C8.44182 10.4 8.79999 10.7582 8.79999 11.2ZM7.99999 3.4C8.33136 3.4 8.59999 3.66863 8.59999 4V8.8C8.59999 9.13137 8.33136 9.4 7.99999 9.4C7.66862 9.4 7.39999 9.13137 7.39999 8.8V4C7.39999 3.66863 7.66862 3.4 7.99999 3.4Z",
    fill: "#FF7816"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Warning.2d2b65f2.svg";
export { ForwardRef as ReactComponent };